.HighTextArea {
  min-height: 134px !important;
}
